// Calendar connections in the Team directory: who has Google or Outlook
// connected, for everyone in the workspace (GET /api/calendar/organizers,
// through lib/meetingCalendar.js; any member may read it), and disconnecting
// your OWN connection (POST /api/calendar/disconnect; backend
// server/calendar/disconnect.js). The server only ever disconnects the
// signed-in person, so the hub offers the button on your own card and your
// own Workspace access row only.
// No em dashes in anything here that reaches the screen.
import { fetchMeetingOrganizers } from "./meetingCalendar";

export const CALENDAR_DISCONNECT_ROUTE = "/api/calendar/disconnect";

export const CALENDAR_PROVIDERS = ["google", "microsoft"];

export const CALENDAR_PROVIDER_LABEL = { google: "Google", microsoft: "Outlook" };

// What the person is about to lose, in the confirm dialog. A Google or
// Microsoft connection carries every permission BossDrop holds for that
// account, so email tracking and meeting notes through it stop too.
export const DISCONNECT_CONFIRM = {
  google: {
    title: "Disconnect your Google account from BossDrop?",
    body:
      "BossDrop stops reading your Google Calendar and can't book meetings on it. " +
      "Email tracking for this Gmail and notes from Google Meet calls you organize stop too.\n\n" +
      "You can connect it again any time.",
  },
  microsoft: {
    title: "Disconnect your Outlook account from BossDrop?",
    body:
      "BossDrop stops reading your Outlook calendar and can't book meetings on it. " +
      "Email tracking for this mailbox and notes from Teams meetings you organize stop too.\n\n" +
      "You can connect it again any time.",
  },
};

/**
 * { [email]: { google: bool, microsoft: bool } } for everyone in the
 * workspace, or null when the list cannot be read. `fetchImpl` is for tests.
 */
export async function fetchCalendarStatusByEmail({ apiBase = "", fetchImpl } = {}) {
  const data = await fetchMeetingOrganizers({ apiBase, fetchImpl });
  if (!data) return null;
  const out = {};
  for (const person of data.people) {
    out[person.email] = { google: !!person.google, microsoft: !!person.microsoft };
  }
  return out;
}

/**
 * Disconnect the signed-in person's own connection for one provider.
 * Resolves the server's answer; throws an Error whose message is the
 * server's error code when it refuses or fails.
 */
export async function disconnectOwnCalendar({ apiBase = "", provider, fetchImpl } = {}) {
  const doFetch = fetchImpl || (typeof fetch === "function" ? fetch : null);
  if (!doFetch) throw new Error("calendar_disconnect_failed");
  const base = String(apiBase || "").replace(/\/+$/, "");
  const res = await doFetch(`${base}${CALENDAR_DISCONNECT_ROUTE}`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ provider }),
  });
  const json = res && typeof res.json === "function" ? await res.json().catch(() => ({})) : {};
  if (!res || !res.ok || json?.ok !== true) {
    throw new Error(String(json?.error || "calendar_disconnect_failed"));
  }
  return json;
}
